import { createContext, ReactNode, useContext } from 'react';
import type { QueryBuilderContextType } from './use-query-builder-store';
import { useQueryBuilderStore } from './use-query-builder-store';

const QueryBuilderContext = createContext<QueryBuilderContextType | undefined>(undefined);

export function useQueryBuilder(): QueryBuilderContextType {
  const context = useContext(QueryBuilderContext);
  if (context === undefined) {
    throw new Error('useQueryBuilder must be used within a QueryBuilderProvider');
  }
  return context;
}

interface QueryBuilderProviderProps {
  children: ReactNode;
}

export function QueryBuilderProvider({ children }: QueryBuilderProviderProps) {
  const value = useQueryBuilderStore();
  return <QueryBuilderContext.Provider value={value}>{children}</QueryBuilderContext.Provider>;
}
